export default __webpack_public_path__ + "static/media/font.96abece0.woff2";